export default {
      id: "oc-k8s-usage",
      viewBox: "0 0 1041 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-k8s",
      toString: function () {
        return this.url;
      }
    }